!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? t(exports, require("react"), require("@material-ui/core/styles"), require("@material-ui/core/Tooltip"), require("@material-ui/core")) : "function" == typeof define && define.amd ? define(["exports", "react", "@material-ui/core/styles", "@material-ui/core/Tooltip", "@material-ui/core"], t) : t((e = e || self)["titular-tooltip"] = {}, e.React, e.styles, e.Tooltip, e.core);
}(this, function (e, t, r, o, a) {
  "use strict";

  t = t && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t, o = o && Object.prototype.hasOwnProperty.call(o, "default") ? o.default : o;

  var _n = function n() {
    return (_n = Object.assign || function (e) {
      for (var t, r = 1, o = arguments.length; r < o; r++) for (var a in t = arguments[r]) Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);

      return e;
    }).apply(this, arguments);
  };

  var i = r.makeStyles(function () {
    return r.createStyles({
      title: {
        fontWeight: 600,
        fontSize: 12
      },
      description: {
        fontSize: 12,
        whiteSpace: "pre-wrap"
      },
      divider: {
        height: 2,
        marginTop: 8,
        marginBottom: 8,
        backgroundColor: "white"
      }
    });
  }),
      l = t.forwardRef(function (e, l) {
    var p = e.title,
        m = e.description,
        s = e.enterDelay,
        c = function (e) {
      return r.makeStyles(function (t) {
        return r.createStyles({
          tooltip: {
            position: "relative",
            maxWidth: e,
            padding: 12
          },
          arrow: {
            position: "absolute",
            opacity: .9,
            fontSize: 6,
            "&::before": {
              content: '""',
              margin: "auto",
              display: "block",
              width: 0,
              height: 0,
              borderStyle: "solid"
            }
          },
          popper: (o = t.palette.grey[700], {
            '&[x-placement*="bottom"] $arrow': {
              top: 0,
              left: 0,
              marginTop: "-0.95em",
              width: "2em",
              height: "1em",
              "&::before": {
                borderWidth: "0 1em 1em 1em",
                borderColor: "transparent transparent " + o + " transparent"
              }
            },
            '&[x-placement*="top"] $arrow': {
              bottom: 0,
              left: 0,
              marginBottom: "-0.95em",
              width: "2em",
              height: "1em",
              "&::before": {
                borderWidth: "1em 1em 0 1em",
                borderColor: o + " transparent transparent transparent"
              }
            },
            '&[x-placement*="right"] $arrow': {
              left: 0,
              marginLeft: "-0.95em",
              height: "2em",
              width: "1em",
              "&::before": {
                borderWidth: "1em 1em 1em 0",
                borderColor: "transparent " + o + " transparent transparent"
              }
            },
            '&[x-placement*="left"] $arrow': {
              right: 0,
              marginRight: "-0.95em",
              height: "2em",
              width: "1em",
              "&::before": {
                borderWidth: "1em 0 1em 1em",
                borderColor: "transparent transparent transparent " + o
              }
            }
          })
        });
        var o;
      })();
    }(e.maxWidth || 196),
        d = c.arrow,
        f = function (e, t) {
      var r = {};

      for (var o in e) Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (r[o] = e[o]);

      if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var a = 0;

        for (o = Object.getOwnPropertySymbols(e); a < o.length; a++) t.indexOf(o[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[a]) && (r[o[a]] = e[o[a]]);
      }

      return r;
    }(c, ["arrow"]),
        u = i(),
        h = t.useState(null),
        y = h[0],
        b = h[1];

    return t.createElement(o, _n({
      ref: l,
      enterDelay: s || 200,
      TransitionProps: {
        timeout: 0
      },
      classes: f,
      PopperProps: _n({
        popperOptions: {
          modifiers: {
            arrow: {
              enabled: Boolean(y),
              element: y
            }
          }
        }
      }, e.PopperProps)
    }, e, {
      title: t.createElement(t.Fragment, null, t.createElement(a.Typography, {
        className: u.title
      }, p), p && m ? t.createElement(a.Divider, {
        className: u.divider
      }) : null, m ? t.createElement(a.Typography, {
        className: u.description
      }, m) : null, t.createElement("span", {
        className: d,
        ref: b
      }))
    }));
  });
  e.TitularTooltip = l, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});